export default __webpack_public_path__ + "static/media/LinkagesImg.587ba538.jpg";